import { render, staticRenderFns } from "./MyBookingView.vue?vue&type=template&id=143b57ea&scoped=true&"
import script from "./MyBookingView.vue?vue&type=script&lang=ts&"
export * from "./MyBookingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b57ea",
  null
  
)

export default component.exports